import api from '~/api'

const state = {
  provider: {},
  providers: {},
}

const getters = {}

const mutations = {}

const actions = {
  publishInternal(_, providersList) {
    return api.post('/providers/publish-internal', { providers: providersList })
  },

  publishInternalDecline(_, providersList) {
    return api.post('/providers/publish-internal/decline', { providers: providersList })
  },

  publishExternal(_, providersList) {
    return api.post('/providers/publish-external', { providers: providersList })
  },

  publishByProvider(_, providerId) {
    return api.post('/publish/provider', { provider: providerId })
  },

  async getPublishing(_, id) {
    const response = await api.get(`publishing-status/${id}`)
    return response
  },

  async getExternalPublishing(_, id) {
    const response = await api.get(`external-publishing-status/${id}`)
    return response
  },

  async getInternalPublishing(_, id) {
    const response = await api.get(`internal-publishing-status/${id}`)
    return response
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
